import React, { useMemo, useEffect, useState } from "react";
import { useWindowScroll } from "react-use";
import classnames from "classnames";
import { useNavigate, useLocation, Link } from "react-router-dom";
// import { Notice } from "../Notice";
import { useTranslation } from "react-i18next";
import { Search } from "../Search";
// import { Button } from "../Button";
import qs from "qs";

import "./styles.less";
import { useGlobalContext } from "../../context/global/context";
import { isBrowser, tryNow } from "../../utils";
import { getUser, logout } from "../../utils/loginState";

export const BlogHeader = (props) => {
  const { mode = "dark", operations, noSearch } = props;
  const { y = 0 } = useWindowScroll();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("home");
  const { state, setValue } = useGlobalContext();
  const { userInfo } = state;
  const [keyword, setKeyword] = useState("");
  const [canPublish, setCanPublish] = useState(false);

  useEffect(() => {
    if (isBrowser) {
      getUser()
        .then((user) => setValue("userInfo", user))
        .catch((e) => console.log(e));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      isBrowser &&
      window._AUTHING__GLOBAL_CONFIG_.blog.publishWhiteList.includes(
        userInfo?.id
      )
    ) {
      setCanPublish(true);
    }
  }, [userInfo]);

  useEffect(() => {
    setKeyword(new URLSearchParams(location.search).get("keyword") ?? "");
  }, [location.search]);

  let { t } = useTranslation();

  const menu = [
    // {
    //   title: `${t("common.nav.nav-home")}`,
    //   key: "home",
    //   url: "/",
    // },
    {
      title: "博客",
      key: "home",
      url: "/blog",
    },
    {
      title: "专题",
      key: "topic",
      url: "/topic",
    },
    {
      title: "活动",
      key: "activity",
      url: "/activity",
    },
  ];

  useEffect(() => {
    const _pathname = location.pathname;

    menu.forEach((m) => {
      if (m.url === _pathname) {
        setActiveKey(m.key);
      } else if (m.children?.some((sub) => sub.url === _pathname)) {
        setActiveKey(m.key);
      }
    });
  }, [location, menu]);

  const clssmode = useMemo(() => {
    return classnames({
      header: true,
      "header-dark": mode === "dark",
      //   "header-light": mode === "light" && y < 10,
      //   backgroud: y > 10 || defaltNav,
      // fixed: y > 34,
      backgroud: true,
      fixed: true,
    });
  }, [mode]);

  const onPageClick = (path) => {
    navigate(`${path}`);
  };

  const onSearch = () => {
    navigate(
      `/blog?${qs.stringify({
        ...qs.parse(location.search.slice(1)),
        keyword,
        page: 1,
      })}`
    );
  };

  const avatarImg =
    userInfo?.picture ||
    userInfo?.photo ||
    "//files.authing.co/authing-website/icon-user-identity.svg";

  return (
    <div>
      {/* <Notice value={t("common.notice")}></Notice> */}
      <header className={clssmode}>
        <div className="warpper">
          <div
            style={{ display: "flex", alignItems: "center", height: "100%" }}
          >
            <Link className="logo" style={{ marginRight: 30 }} to="/">
              {mode === "light" && y < 10 ? (
                <img
                  src={
                    "//files.authing.co/authing-website/authing-logo-white.svg"
                  }
                  alt="authing logo"
                />
              ) : (
                <img
                  src={
                    "//files.authing.co/authing-website/authing-logo-0830.png"
                  }
                  alt="authing logo"
                />
              )}
            </Link>
            <div className="nav">
              {menu.map((item, index) => {
                const cls = classnames({
                  "blog-nav-item": true,
                  selected: activeKey === item.key,
                });

                return (
                  <div
                    key={index}
                    className={cls}
                    onClick={() => {
                      // if (!item.children || !item.children.length) {
                      item.url && onPageClick(item.url);
                      // }
                    }}
                  >
                    {item.title}
                    {item.children && item.children.length && (
                      <div className="item-block">
                        {item.children.map((sub, index) => (
                          <div
                            key={index}
                            className="item"
                            onClick={(e) => {
                              e.stopPropagation();
                              onPageClick(sub.url);
                            }}
                          >
                            {sub.title}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          {!noSearch && (
            <div className="center-opts">
              <Search
                onSearch={onSearch}
                onChange={(evt) => setKeyword(evt.target.value)}
                value={keyword}
                onKeyDown={(evt) => {
                  if (evt.keyCode === 13) {
                    onSearch();
                  }
                }}
                placeholder="搜索文章标题和内容"
                icon={true}
              />
              {canPublish && (
                <div
                  onClick={() => navigate("/blog/publish")}
                  className="search-button"
                >
                  发表博文
                </div>
              )}
            </div>
          )}
          <div className="options">
            {operations ? (
              operations
            ) : (
              <div className="console" onClick={tryNow}>
                <i
                  className="icon authing-icon authing--_jiantou"
                  style={{ fontSize: 14 }}
                ></i>
                免费注册，打造高效身份管理
              </div>
            )}
            {/* {userInfo ? (
              <div className="user-box">
                <div className="user-img">
                  <img src={avatarImg} alt="authing avatar" />
                </div>
                <div className="user-options">
                  <div className="item" onClick={tryNow}>
                    {t("common.nav.nav-console")}
                  </div>
                  <div
                    className="item"
                    onClick={() => {
                      window.location.href = "https://console.authing.cn/u";
                    }}
                  >
                    {t("common.nav.nav-personal")}
                  </div>
                  <div
                    className="item"
                    onClick={async () => {
                      await logout();
                      window.location.reload();
                    }}
                  >
                    {t("common.nav.nav-logout")}
                  </div>
                </div>
              </div>
            ) : (
              <div className="login" onClick={tryNow}>
                {t("common.nav.nav-login")}
              </div>
            )} */}
          </div>
        </div>
      </header>
    </div>
  );
};
